import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ModalContainer from '../../containers/modal';

import FluidContainer from '../layouts/components/fluid-container';

import { showModal, hideReport, showReport } from '../../actions/modal';
import Button from '../button';
import { GotoSourceButton } from '../buttons-bar';
import { SOURCES } from '../../constants/sources';
import { useWindowSize } from '../../lib/hooks';
import { REPORT_MODAL } from '../../containers/modal/modal-types';
import DefaultLayout from '../layouts/deafult-layout';
import theme from '../../theme';

const ButtonContainer = styled.div`
    margin: 0 0 calc(var(--space-unit) * 2) 0;
    & > button {
        width: 100%;
    }

    & > a {
        width: 100%;
    }

    ${(props) => props.theme.mediaQueries.tablet} {
        margin: 0 calc(var(--space-unit) * 2) 0 0;
    }
`;

const ButtonsContainer = styled(FluidContainer)`
    margin-top: calc(var(--space-unit) * 4);
`;

const ErrorLayout = ({ children, hideReport, showModal, showReport, displayReport }) => {
    const { innerWidth } = useWindowSize();

    const isMobileTablet = innerWidth < theme.breakpoints.desktop;

    const handleClickReport = () => {
        if (isMobileTablet) {
            showModal(REPORT_MODAL);
            showReport();
            return;
        }
        if (displayReport) {
            hideReport();
            return;
        }
        showReport();
    };

    return (
        <DefaultLayout exercises={[]} status={{}} profile={{ status: {} }} errorLayout={true}>
            <ModalContainer />

            <FluidContainer flexDirection="column" maxWidth={['100%', '100%', '100%']} paddingTop={[178, 168, 140]}>
                {children}
                <br />
                <ButtonsContainer flexDirection={['column', 'row', 'row']}>
                    <ButtonContainer>
                        <GotoSourceButton source={SOURCES.LAZE} type="primary" />
                    </ButtonContainer>
                    <ButtonContainer>
                        <Button type="tertiary" onClick={() => handleClickReport()} size="small">
                            {'Contattaci'}
                        </Button>
                    </ButtonContainer>
                </ButtonsContainer>
            </FluidContainer>
        </DefaultLayout>
    );
};

ErrorLayout.propTypes = {
    children: PropTypes.node,
    hideReport: PropTypes.func,
    showModal: PropTypes.func,
    showReport: PropTypes.func,
    displayReport: PropTypes.bool,
};

function mapStateToProps(state) {
    return {
        displayReport: state.modal.showReport,
    };
}

const actionCreators = {
    hideReport,
    showModal,
    showReport,
};

export default connect(mapStateToProps, actionCreators)(ErrorLayout);
